<template>
  <div>
    <video-player
      v-if="mediaType === 'video'"
      :item="videoItem"
      :active="true"
      :popup="false"
      :taking="false"
      :testing="false"
      :options="{}"
    />

    <action-entertain-audio-player
      v-if="mediaType === 'audio'"
      :url="state.audioUrl"
    />

    <div class="entertain-menu-bar pa-3" v-if="showTypeSwitcher">
      <v-btn @click="setMediaType('video')" class="primary">
        Watch Video
      </v-btn>
      <v-btn @click="setMediaType('audio')" class="ml-3 primary">
        Listen
      </v-btn>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/views/lessons/lessonWidgets/videoWidget/VideoPlayer';
import ActionEntertainAudioPlayer from '@/components/rooms/actions/entertain/ActionEntertainAudioPlayer';

export default {
  name: 'ActionEntertainContent',
  components: {
    VideoPlayer,
    ActionEntertainAudioPlayer,
  },
  props: {
    state: {},
  },
  data() {
    return {
      mediaType: 'video',
    };
  },
  computed: {
    videoItem() {
      return {
        values: {
          url: this.state.videoUrl,
          summary: {},
        },
      };
    },
    showTypeSwitcher() {
      const { videoUrl, audioUrl } = this.state;
      return !!videoUrl && !!audioUrl;
    },
  },
  methods: {
    setMediaType(type) {
      this.mediaType = type;
    },
  },
  mounted() {
    if (!this.state.videoUrl) {
      this.setMediaType('audio');
    }
  },
};
</script>

<style>
.entertain-menu-bar {
  background-color: var(--v-appMain-base);
  margin-right: 0;
  margin-left: 0;
  min-height: 46px;
}
</style>
